<template>
  <label
    :for="id"
    class="form-label"
    :class="{
      'form-label--is-invalid': error,
    }"
  >
    <slot>
      {{ labelText }}
    </slot>
  </label>
</template>

<script>
  export default {
    name: 'FormLabel',
    props: {
      id: {
        type: String,
        required: true,
      },
      labelText: {
        type: String,
        required: false,
        default: '',
      },
      error: Boolean,
    },
  };
</script>

<style lang="scss" scoped>
  .form-label {
    color: #4a4a4a;
    font-size: 16px;
    font-weight: 600;
    margin: 0;
    display: block;

    &--is-invalid {
      color: var(--itr-color-danger);
    }
  }
</style>
